import React from 'react';
import { TEXT_STYLE_PRESETS } from '../../../utils/textStylePresets';
import CaptionStylePopup from './CaptionStylePopup';
import CaptionPresetButton from './CaptionPresetButton';

const TextPropertiesSection = ({
  element,
  isTextContentFocused,
  setIsTextContentFocused,
  textContentInput,
  setTextContentInput,
  isTextPopupOpen,
  setIsTextPopupOpen,
  onUpdateTextProp,
}) => {
  const componentData = element.componentData || {};
  const textPopupAnchorRef = React.useRef(null);

  const applyTextPreset = (preset) => {
    onUpdateTextProp('fontFamily', preset.fontFamily);
    onUpdateTextProp('fontSize', preset.fontSize);
    onUpdateTextProp('color', preset.color);
  };

  return (
    <div className="space-y-3 px-3 py-3">
      <div className="p-3 bg-ag-black-800 rounded-lg border border-ag-black-600">
        <details open>
          <summary className="text-xs font-medium text-white cursor-pointer select-none flex items-center justify-between">
            <span>Text</span>
            <svg className="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </summary>
          <div className="mt-2">
            <textarea
              value={isTextContentFocused ? textContentInput : componentData.text || 'Text'}
              onFocus={() => {
                setIsTextContentFocused(true);
                setTextContentInput(componentData.text || '');
              }}
              onChange={(event) => {
                setTextContentInput(event.target.value);
                onUpdateTextProp('text', event.target.value);
              }}
              onBlur={() => {
                if (!textContentInput.trim()) {
                  onUpdateTextProp('text', 'Text');
                }
                setTextContentInput('');
                setIsTextContentFocused(false);
              }}
              rows={3}
              className="w-full px-2 py-1.5 text-xs bg-ag-black-900 border border-ag-black-500 rounded text-white focus:outline-none focus:ring-1 focus:ring-ag-green resize-none leading-relaxed"
            />
          </div>
        </details>
      </div>

      <div className="p-3 bg-ag-black-800 rounded-lg border border-ag-black-600 relative">
        {isTextPopupOpen && (
          <CaptionStylePopup
            currentStyle={{
              fontFamily: componentData.fontFamily || 'Inter',
              fontSize: componentData.fontSize || 48,
              color: componentData.color || '#ffffff',
            }}
            mode="text"
            anchorRef={textPopupAnchorRef}
            onChange={(newStyle) => {
              if (newStyle.fontFamily !== undefined) onUpdateTextProp('fontFamily', newStyle.fontFamily);
              if (newStyle.fontSize !== undefined) onUpdateTextProp('fontSize', newStyle.fontSize);
              if (newStyle.color !== undefined) onUpdateTextProp('color', newStyle.color);
            }}
            onClose={() => setIsTextPopupOpen(false)}
          />
        )}

        <details>
          <summary
            ref={textPopupAnchorRef}
            className="text-xs font-medium text-white cursor-pointer select-none flex items-center justify-between"
          >
            <div className="flex items-center gap-1">
              <span>Style</span>
              <svg className="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <button
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                setIsTextPopupOpen(!isTextPopupOpen);
              }}
              className="hover:bg-gray-700 p-0.5 rounded transition-colors text-white focus:outline-none"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="5" cy="12" r="2" />
                <circle cx="12" cy="12" r="2" />
                <circle cx="19" cy="12" r="2" />
              </svg>
            </button>
          </summary>

          <div className="mt-2 grid grid-cols-2 gap-x-2 gap-y-3 max-h-[300px] overflow-y-auto transcript-scroll pr-3">
            {TEXT_STYLE_PRESETS.map((preset) => (
              <CaptionPresetButton key={preset.key} preset={preset} updateStyle={applyTextPreset} />
            ))}
          </div>
        </details>
      </div>
    </div>
  );
};

export default TextPropertiesSection;
